@if (loadTypeList) {
  <p-select
    [appendTo]="'body'"
    (onChange)="onLoadTypeChange($event)"
    [options]="loadTypeList"
    [(ngModel)]="loadType"
    filterBy="label, value"
    [disabled]="disabled()"
    [showClear]="showClear()"
    [placeholder]="placeholder"
  >
    <ng-template #selectedItem>
      @if (loadType) {
        <p-chip
          [label]="getLoadTypeLabel(loadType)"
          [removable]="!disabled()"
          removeIcon="pi pi-times"
          (onRemove)="clearLoadType()"
        />
      }
    </ng-template>
  </p-select>
}
